var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 20.7536C-1.17157 16.0673 -1.17157 8.46929 3.51471 3.78296C3.51438 3.78347 10.4348 12.2683 10.4348 12.2683L3.51471 20.7536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4341 12.2667L1.59089 6.29077C1.31672 6.76735 1.07494 7.26479 0.867188 7.77966L5.34417 12.2668L0.867328 16.7541C1.07489 17.2686 1.31644 17.7657 1.59042 18.242L10.4341 12.2667Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8972 10.7029H10.4332L3.51336 3.78296C2.76767 4.52865 2.11981 5.37197 1.59031 6.29218L7.55464 12.2681L1.58984 18.2432C2.11934 19.1637 2.76748 20.0073 3.51336 20.7532L10.4332 13.8333H23.8972C23.9639 13.3209 23.9988 12.7986 23.9988 12.2681C23.9988 11.7376 23.9639 11.2152 23.8972 10.7029Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69336 21.785C6.71691 23.3404 9.24989 24.2658 11.9994 24.2658C17.5437 24.2658 22.209 20.5054 23.586 15.3962H11.0822L4.69336 21.785Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.586 9.13688C22.209 4.02769 17.5437 0.267334 11.9994 0.267334C9.24989 0.267334 6.71691 1.19269 4.69336 2.7481L11.0821 9.13688H23.586Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ZAR.b794747f9feddd2f15fb378b3208de93.svg";